// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__zFCxU","notes":"Notes_notes__3WlKo","note":"Notes_note__36Yu-","markdown":"Notes_markdown__2R2_B"};